<template>
  <div class="ff-mrgn-t-60">
    <div class="flex-r ff-pdng-b-20">
      <div class="size-85">
        <base-input
                v-model.trim="$v.creditCard.holder.$model"
                :is-have-error="$v.creditCard.holder.$error"
                label="Имя держателя карты"
                placeholder="ARTEM GAPANOVICH"
                :disabled="isActive"
        >
          <div
                  v-if="$v.creditCard.holder.$error"
                  class="f-input-text"
          >
            <template v-if="!$v.creditCard.holder.required">
              Имя держателя карты обязательно.
            </template>

            <template v-else-if="!$v.creditCard.holder.holderName">
              Имя держателя карты должно быть написано латинецей
            </template>
          </div>
        </base-input>
      </div>
    </div>

    <div class="flex-r ff-pdng-b-20">
      <div class="section size-60">
        <base-input
                v-model.trim="$v.creditCard.number.$model"
                :is-have-error="$v.creditCard.number.$error"
                label="Номер карты"
                placeholder="0000 0000 0000 0000"
                :disabled="isActive"
        >
          <div
                  v-if="$v.creditCard.number.$error"
                  class="f-input-text"
          >
            <template v-if="!$v.creditCard.number.required">
              Номер карты обязателен.
            </template>

            <template v-else-if="!$v.creditCard.number.cardNumber">
              Невалидный номер карты
            </template>
          </div>
        </base-input>
      </div>
      <div class="section size-5"></div>
      <div class="section size-20">
        <base-input
                v-model.trim="$v.creditCard.verificationValue.$model"
                :is-have-error="$v.creditCard.verificationValue.$error"
                label="CVC код"

                placeholder="CVC"
                :disabled="isActive"
        >
          <div
                  v-if="$v.creditCard.verificationValue.$error"
                  class="f-input-text"
          >
            <template v-if="!$v.creditCard.verificationValue.required">
              CVC обязателен.
            </template>

            <template v-else-if="!$v.creditCard.verificationValue.cvc">
              Невалидное CVC
            </template>
          </div>
        </base-input>
      </div>

    </div>

    <div class="flex-r ff-pdng-b-20">
      <div class="section size-15">
        <base-input
                v-model.trim="$v.creditCard.expMonth.$model"
                :is-have-error="$v.creditCard.expMonth.$error"
                label="ММ"
                placeholder="ММ"
                :disabled="isActive"
        >
          <div
                  v-if="$v.creditCard.expMonth.$error"
                  class="f-input-text"
          >
            <template v-if="!$v.creditCard.expMonth.required">
              Месяц окончания обязателен
            </template>

            <template v-else-if="!$v.creditCard.expMonth.cardMonth">
              Месяц окончания невалидный
            </template>
          </div>
        </base-input>
      </div>
      <div class="section size-5"></div>
      <div class="section size-15">
        <base-input
                v-model.trim="$v.creditCard.expYear.$model"
                :is-have-error="$v.creditCard.expYear.$error"
                label="ГГ"
                placeholder="ГГ"
                :disabled="isActive"
        >
          <div
                  v-if="$v.creditCard.expYear.$error"
                  class="f-input-text"
          >
            <template v-if="!$v.creditCard.expYear.required">
              Год окончания обязателен
            </template>

            <template v-else-if="!$v.creditCard.expYear.cardYear">
              Год окончания невалидный
            </template>
          </div>
        </base-input>
      </div>
      <div class="section size-5"></div>




    </div>
  </div>
</template>

<script>
import { required, numeric } from 'vuelidate/lib/validators';
import holderName from '@/validators/rule/holderName';
import cardNumber from '@/validators/rule/cardNumber';
import cvc from '@/validators/rule/cvc';
import cardMonth from '@/validators/rule/cardMonth';
import cardYear from '@/validators/rule/cardYear';
import cloneDeep from 'lodash.clonedeep';
import { card, expiration } from 'creditcards';

export default {
  name: 'BankCardPaymentForm',
  validations: {
    creditCard: {
      number: {
        required,
        cardNumber
      },
      verificationValue: {
        required,
        cvc
      },
      holder: {
        required,
        holderName
      },
      expMonth: {
        required,
        cardMonth
      },
      expYear: {
        required,
        cardYear
      }
    }
  },
  model: {
    event: 'input',
    prop: 'originalCreditCard'
  },
  props: {
    originalCreditCard: {
      type: Object,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      creditCard: cloneDeep(this.originalCreditCard)
    };
  },
  watch: {
    'creditCard': {
      deep: true,
      handler() {
        this.$emit('input', cloneDeep(this.creditCard));
      }
    },
    'creditCard.holder'(value) {
      const upperHolder = value.toUpperCase();

      if (upperHolder !== this.creditCard.holder) {
        this.creditCard.holder = upperHolder;
      }
    },
    'creditCard.expMonth'(value) {
      const parsedCardMonth = expiration.month.parse(value);

      if (parsedCardMonth !== this.creditCard.expMonth) {
        this.creditCard.expMonth = parsedCardMonth;
      }
    },
    'creditCard.expYear'(value) {
      const parsedCardYear = expiration.year.parse(value);

      if (parsedCardYear !== this.creditCard.expYear) {
        this.creditCard.expYear = parsedCardYear;
      }
    },
    'creditCard.number'(value) {
      const formattedNumber = card.format(
        card.parse(value)
      );

      if (formattedNumber !== this.creditCard.number) {
        this.creditCard.number = formattedNumber;
      }
    }
  },
  methods: {
    isValid() {
      return !this.$v.$invalid;
    }
  }
}
</script>
